<template>
  <div id="interupt" class='interupt'>
    <div class="back"></div>
    <div class='table-content'>
      <div class="cell-content">
        <img src='./../assets/compass.svg' width="44">
        <div class='padding-20'></div>
        För att delta i tävlingen måste spelet använda din enhets platsinformation<br>
        <h6><u v-on:click="openTurnOn">Läs steg för steg instruktioner för iOS och Android här!</u><br><br><u v-on:click="laddaOmSida">Ladda om sidan</u><br><br></h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'errupt',
  computed: {
  },
  mounted () {
  },
  methods: {
    laddaOmSida () {
      window.location.reload()
    },
    openHowGPS () {
      let htmlString = '<h1>Hur ger jag tillåtelse</h1><p>1.</p><p>2.</p>'
      this.$store.commit('openTextPage', htmlString)
    },
    openpopup () {
      let htmlString = '<h1>Godkänn att spelet använder platsinformation</h1><p>Det är möjligt att du råkat avböja spelets förfrågan om att få tillgång till din platsinformation.</p> Se till att webbplatsen är godkänd att använda platsinformation.'
      this.$store.commit('openTextPage', htmlString)
    },
    openTurnOn () {
      let html = '<h1>Besöker du sidan genom facebooks webbläsare?</h1><br>Då måste du välja att öppna sidan i din telefons vanliga webbläsare. Det gör du genom att antingen kopiera länken in i din vanliga webbläsare eller trycka på menyn uppe till höger där du kan välja att göra detta<br><br>'
      html += '<h1>Så här aktiverar du mobilens platstjänster</h1>'
      html += '<br><b>Aktivera platstjänster på Apple iOS</b><br>'
      html += '<ol>'
      html += '<li>Öppna inställningar. Leta efter appen inställningar på din iOS-enhet och tryck på den.</li>'
      html += '<li>Gå till platstjänster. Tryck på "Sekretess" i menyn Inställningar och tryck sedan på "Platstjänster".</li>'
      html += '<li>Välj att aktivera platstjänster.</li>'
      html += '<li>Välj sedan att aktivera för din webbläsare tex. Safari, google chrome eller firefox.</li>'
      html += '</ol>'
      html += '<br><br>'
      html += '<b>Aktivera platstjänster på Android</b><br>'
      html += '<ol>'
      html += '<li>Gå till Inställningar och sedan Platstjänster:'
      html += '<ul><li>Vid använd trådlösa nätverk: Välj att aktivera</li><li>Vid använd GPS-satelliter: Välj att aktivera</li><li>Vid plats och Google-sökning: Välj att aktivera</li></ul>'
      html += '<li>I menyn gå till internet, tryck på menyknappen, välj sekretess sedan säkerhet och sist plats</li>'
      html += '<li>Tillåt platsåtkomst: Aktivera</li>'
      html += '</ol>'
      html += '<br>Nu borde du få en notifikation i din webbläsare när hemsidan frågar efter din plats.'
      this.$store.commit('openTextPage', html)
    },
    openGPSTerms () {
      let htmlString = '<h1>Hur används min platsinformation?</h1><p>lsls</p><p>lal</p>'
      this.$store.commit('openTextPage', htmlString)
    }
  },
  components: { }
}
</script>

<style scoped>
.interupt {
  position: fixed;
  top: 0px;
  color: #fff;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999999998;
}
h6 {
  line-height: 30px;
}
.back {
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  position: absolute;
  background-color: #234;
  opacity: 0.8;  
}
.table-content {
  display: table;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  text-align: center;
}
.cell-content {
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  padding: 24px;
  font-size: 22px;
}

</style>



// WEBPACK FOOTER //
// errupt.vue?8433db86